import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { FaCheck } from 'react-icons/fa';

export default function Register() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{6,50}$/;
    return passwordRegex.test(password);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    
    // Validate password
    if (!validatePassword(password)) {
      setError('Password must be between 6 and 50 characters and include at least one uppercase letter, one lowercase letter, one number, and one special character.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (!firstName || !lastName || !email || !dateOfBirth || !address || !phoneNumber) {
      setError('Please fill out all required fields.');
      return;
    }

    // Log the data being sent to the API
    const data = {
      firstName,
      lastName,
      password,
      confirmPassword,
      dateOfBirth,
      address,
      email,
      phoneNumber,
    };

    console.log('Data being sent to API:', data);

    try {
      const response = await axios.post('https://fboothapi.azurewebsites.net/api/auth/register', data);

      if (response.status === 200) {
        navigate('/login');
      } else {
        setError('Registration failed. Please check your details.');
      }
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 200 range
        console.error('Error response:', error.response.data);
        setError(error.response.data?.message || 'Registration failed. Please check your details.');
      } else if (error.request) {
        // Request was made but no response received
        console.error('Error request:', error.request);
        setError('No response from the server. Please try again later.');
      } else {
        // Something else happened
        console.error('Error message:', error.message);
        setError('Registration failed. Please check your details.');
      }
    }
  };

  return (
    <div className="h-full pt-10 pb-60">
      <div className="mx-auto">
        <div className="flex justify-center px-6 py-12">
          <div className="w-full xl:w-3/4 lg:w-11/12 flex rounded-lg shadow">
            <div className="w-full h-auto bg-gray-400 hidden lg:block lg:w-5/12 bg-cover rounded-l-lg">
              <img src={require('../../assets/homepage1.jpg')} alt="User Cover"
                className='w-full h-full rounded-tl-lg rounded-bl-lg ' />
            </div>
            <div className="w-full lg:w-7/12 bg-white p-5 rounded-lg lg:rounded-l-none">
              <h3 className="py-4 text-2xl text-center text-gray-800">Register</h3>
              <form className="px-8 pt-6 pb-8 mb-4 bg-white rounded" onSubmit={handleRegister}>
                <div className="flex mb-4 space-x-4">
                  <div className="w-1/2">
                    <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="firstName">First Name</label>
                    <input
                      className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      id="firstName"
                      type="text"
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                      placeholder="First Name"
                    />
                  </div>
                  <div className="w-1/2">
                    <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="lastName">Last Name</label>
                    <input
                      className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      id="lastName"
                      type="text"
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                      placeholder="Last Name"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="email">Email</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="password">Password</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                  />
                  <p className="text-xs text-gray-600 mt-1">
                    Password must be between 6 and 50 characters.
                  </p>
                  <p className="text-xs text-gray-600 mt-1">Include at least one uppercase letter, one lowercase letter, one special character and one number.</p>
                </div>
                <div className="mb-4 relative">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="confirmPassword">Confirm Password</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="confirmPassword"
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm Password"
                  />
                  {password && confirmPassword && password === confirmPassword && (
                    <FaCheck className="absolute top-1/2 right-3 transform -translate-y-1/2 text-green-500" />
                  )}
                </div>
                <div className="flex mb-4 space-x-4">
                  <div className="w-1/2">
                    <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="dateOfBirth">Date of Birth</label>
                    <input
                      className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      id="dateOfBirth"
                      type="date"
                      value={dateOfBirth}
                      onChange={(e) => setDateOfBirth(e.target.value)}
                      placeholder="Date of Birth"
                    />
                  </div>
                  <div className="w-1/2">
                    <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="phoneNumber">Phone Number</label>
                    <input
                      className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      id="phoneNumber"
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      placeholder="Phone Number"
                    />
                  </div>
                </div>
                <div className="mb-4">
                  <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="address">Address</label>
                  <input
                    className="w-full px-3 py-2 mb-3 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                    id="address"
                    type="text"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Address"
                  />
                </div>
                {error && <p className="text-red-500 text-xs italic">{error}</p>}
                <div className="mb-6 text-center">
                  <button
                    className="w-full px-4 py-2 font-bold text-white bg-blue-500 rounded-full hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-900 focus:outline-none focus:shadow-outline"
                    type="submit"
                  >
                    REGISTER
                  </button>
                </div>
                <div className="text-center">
                  <p className="text-gray-600 text-sm">
                    You have an account? 
                    <Link to="/login" className="text-blue-500 hover:underline"> Login Now</Link>
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
